import { useEffect, useState } from 'react';

import { BREAKPOINTS } from 'constants/breakpoints';

export type ViewportSize = 'mobile' | 'small' | 'medium' | 'large' | 'xlarge';

const getViewportSize = (): ViewportSize => {
	const width = window.innerWidth;

	if (width >= BREAKPOINTS.xlarge) return 'xlarge';
	if (width >= BREAKPOINTS.large) return 'large';
	if (width >= BREAKPOINTS.medium) return 'medium';
	if (width >= BREAKPOINTS.small) return 'small';
	return 'mobile';
};

// Must match SSR and the client's first paint so hydration doesn't diverge
// when the real window width differs (e.g. mobile browser vs SSR default).
const SSR_DEFAULT_VIEWPORT: ViewportSize = 'large';

export const useViewport = () => {
	const [viewportSize, setViewportSize] =
		useState<ViewportSize>(SSR_DEFAULT_VIEWPORT);

	useEffect(() => {
		const handleResize = () => {
			setViewportSize(getViewportSize());
		};

		// Resolve real size after mount (same as SSR on first client paint)
		handleResize();
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return {
		viewportSize,
		isMobile: viewportSize === 'mobile' || viewportSize === 'small',
		isTablet: viewportSize === 'medium',
		isDesktop: viewportSize === 'large' || viewportSize === 'xlarge',
	};
};
